import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import Logo from '../components/Logo';

const TermsConditions = () => {
  const navigate = useNavigate();

  const openWhatsApp = () => {
    window.open('https://wa.me/919515698775', '_blank');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* WhatsApp Floating Button */}
      <button
        onClick={openWhatsApp}
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all hover:scale-110"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-6 w-6" />
      </button>

      {/* Header */}
      <header className="bg-white shadow-sm">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center space-x-3">
            <Logo size={48} />
            <span className="text-2xl font-bold text-gray-900">Reload Freight</span>
          </div>
        </nav>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Button 
          onClick={() => navigate('/')} 
          variant="outline" 
          className="mb-8"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Button>

        <Card className="shadow-lg">
          <CardContent className="p-8 md:p-12">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
              Terms & Conditions
            </h1>

            <div className="space-y-8 text-gray-700">
              {/* Section 1 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  1. About ReLoad Freight
                </h2>
                <div className="space-y-3">
                  <p>
                    ReLoad Freight is a logistics coordination platform that connects customers with truck owners who have return trips available.
                  </p>
                  <p>
                    We do not own trucks and do not act as a transporter. We facilitate coordination between customers and truck owners.
                  </p>
                </div>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  2. Role of ReLoad Freight
                </h2>
                <div className="space-y-3">
                  <p>
                    ReLoad Freight provides information and contact details to help users connect.
                  </p>
                  <p>
                    Pricing, loading, unloading, and delivery are mutually agreed between customer and truck owner.
                  </p>
                  <p>
                    ReLoad Freight is not responsible for delays caused by traffic, weather, breakdowns, or third-party issues.
                  </p>
                </div>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  3. User Responsibility
                </h2>
                <div className="space-y-3">
                  <p>
                    Customers must clearly communicate load details before booking.
                  </p>
                  <p>
                    Truck owners must provide accurate trip and vehicle information.
                  </p>
                  <p>
                    Both parties are responsible for lawful transport of goods.
                  </p>
                </div>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  4. Payments
                </h2>
                <div className="space-y-3">
                  <p>
                    Payment terms are decided directly between customer and truck owner unless stated otherwise.
                  </p>
                  <p>
                    ReLoad Freight does not guarantee payment collection unless explicitly mentioned.
                  </p>
                </div>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  5. Cancellations & Disputes
                </h2>
                <div className="space-y-3">
                  <p>
                    Any cancellation or dispute should be communicated immediately.
                  </p>
                  <p>
                    ReLoad Freight may assist in coordination but is not legally liable for disputes between users.
                  </p>
                </div>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  6. Changes to Service
                </h2>
                <p>
                  ReLoad Freight may modify services, routes, or policies as the platform evolves.
                </p>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  7. Acceptance
                </h2>
                <p>
                  By using this website, you agree to these Terms & Conditions.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-3">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <Logo size={36} />
              <span className="text-xl font-bold">Reload Freight</span>
            </div>
            <p className="text-gray-300">
              © 2025 Reload Freight Technologies Private Limited | All rights reserved
            </p>
            <p className="text-gray-400 text-sm">
              Contact: +91 9515698775
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsConditions;
